export const hostUrl =
  process.env.NODE_ENV === "development"
    ? // ? 'https://cdha.imisig.cdha.ca/CDHACommon'
      // `https://www.imis20dev.cdha.ca/CDHACommon`
      `https://www.cdha.ca/CDHACommon`
    : // `https://www.cdha.ca/CDHACommon`
      // `https://www.cdha.ca/CDHACommon`
      `//${window.location.hostname}/CDHACommon`;

export const connectUrl = "https://cdha.adobeconnect.com/api/xml";

export const graphqlUrl = "https://cdha.leoalves.net/v1alpha1/graphql";
export const subscriptionUrl = "wss://cdha.leoalves.net/v1alpha1/graphql";
